(function () {
  function absUrl(u) {
    if (!u) return u;
    if (u.indexOf("//") === 0) return "https:" + u;
    return u;
  }

  function setPct(el, n) {
    if (el) el.textContent = Math.max(0, Math.min(100, Math.round(n))) + "%";
  }

  function parseGlb(buffer) {
    const dv = new DataView(buffer);
    if (dv.getUint32(0, true) !== 0x46546c67) throw new Error("not-glb");
    let o = 12;
    const jsonLen = dv.getUint32(o, true);
    o += 8;
    const json = JSON.parse(new TextDecoder().decode(new Uint8Array(buffer, o, jsonLen)));
    o += jsonLen;
    const binLen = dv.getUint32(o, true);
    o += 8;
    const bin = buffer.slice(o, o + binLen);
    return { json: json, bin: bin };
  }

  function accessorArray(json, bin, index) {
    const a = json.accessors[index];
    const bv = json.bufferViews[a.bufferView];
    const offset = (bv.byteOffset || 0) + (a.byteOffset || 0);
    const count = a.count;
    const type = a.type;
    const comps = type === "VEC3" ? 3 : type === "VEC2" ? 2 : 1;
    const slice = bin.slice(offset, offset + count * comps * (a.componentType === 5126 ? 4 : a.componentType === 5125 ? 4 : 2));
    if (a.componentType === 5126) return new Float32Array(slice);
    if (a.componentType === 5125) return new Uint32Array(slice);
    return new Uint16Array(slice);
  }

  function imageBitmapFromView(json, bin, imageIndex) {
    const img = json.images[imageIndex];
    const bv = json.bufferViews[img.bufferView];
    const bytes = bin.slice(bv.byteOffset || 0, (bv.byteOffset || 0) + bv.byteLength);
    const blob = new Blob([bytes], { type: img.mimeType || "image/png" });
    if (window.createImageBitmap) return createImageBitmap(blob);
    return new Promise(function (resolve, reject) {
      const el = new Image();
      el.onload = function () {
        resolve(el);
      };
      el.onerror = reject;
      el.src = URL.createObjectURL(blob);
    });
  }

  function loadGlb(url, onProgress) {
    return new Promise(function (resolve, reject) {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "arraybuffer";
      xhr.onprogress = function (e) {
        if (e.lengthComputable) onProgress((e.loaded / e.total) * 100);
      };
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) resolve(xhr.response);
        else reject(new Error("glb-" + xhr.status));
      };
      xhr.onerror = function () {
        reject(new Error("glb-network"));
      };
      xhr.send();
    });
  }

  const root = document.querySelector("[data-rof3d]");
  if (!root) return;

  const cfg = JSON.parse(document.getElementById("rof-3d-config").textContent);
  const canvas = root.querySelector("[data-canvas]");
  const loaderEl = root.querySelector("[data-loader]");
  const pctEl = root.querySelector("[data-loader-pct]");
  const fallback = root.querySelector("[data-fallback]");
  const stage = root.querySelector("[data-stage]");
  const spotEl = root.querySelector("[data-spot]");
  const hotRoot = root.querySelector("[data-hotspots]");
  const debugWanted = /(?:\?|&)debug3d=true(?:&|$)/.test(location.search);
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const mobile = window.matchMedia("(max-width: 749px)").matches;
  const low =
    mobile ||
    (navigator.deviceMemory && navigator.deviceMemory <= 4) ||
    (navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4);

  const HOTSPOTS = [
    { id: "chest", label: "Embroidered mark", index: "01", uv: [0.38, 0.36], side: "front" },
    { id: "zip", label: "Double zip", index: "02", uv: [0.5, 0.52], side: "front" },
    { id: "pocket", label: "Velvet pocket", index: "03", uv: [0.36, 0.58], side: "front" },
    { id: "sleeve", label: "Sleeve mark", index: "04", uv: [0.86, 0.62], side: "front" },
    { id: "tiger", label: "Appliqué tiger", index: "05", uv: [0.38, 0.58], side: "back" },
    { id: "wordmark", label: "House wordmark", index: "06", uv: [0.54, 0.5], side: "back" }
  ];

  function fallbackMode() {
    if (loaderEl) loaderEl.classList.add("is-gone");
    if (stage) stage.hidden = true;
    if (fallback) fallback.hidden = false;
  }

  if (reduced || !canvas || !window.WebGLRenderingContext) {
    fallbackMode();
    return;
  }

  const THREE = window.THREE;
  if (!THREE) {
    fallbackMode();
    return;
  }

  const easeOut = (t) => 1 - Math.pow(1 - t, 3);
  const easeInOut = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
  const lerp = (a, b, t) => a + (b - a) * t;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

  const home = { theta: 0.58, phi: 1.18, radius: mobile ? 3.18 : 2.82 };
  const introFrom = { theta: 1.18, phi: 1.08, radius: mobile ? 3.58 : 3.28 };
  const look = {
    theta: introFrom.theta,
    phi: introFrom.phi,
    radius: introFrom.radius,
    targetY: 0.02,
    vTheta: 0,
    vPhi: 0,
    vRadius: 0
  };
  const lim = { phiMin: 0.55, phiMax: 1.52, rMin: mobile ? 1.85 : 1.72, rMax: mobile ? 3.85 : 3.7 };
  let touched = false;

  let renderer;
  let scene;
  let camera;
  let garment;
  let key;
  let fill;
  let rim;
  let hemi;
  let pointerLight;
  let floor;
  let ready = false;
  let interactive = false;
  let dragging = false;
  let film = false;
  let filmT = 0;
  let filmDur = 20;
  let introT = -1;
  let anim = null;
  let last = performance.now();
  const pointer = { x: 0, y: 0, tx: 0, ty: 0 };
  const hotEls = [];
  const debug = {
    key: 1.35,
    fill: 0.58,
    rim: 0.92,
    hemi: 0.62,
    exposure: 1.18,
    env: 0.28,
    rough: 0.86,
    fov: mobile ? 38 : 32,
    posY: 0.0
  };

  try {
    renderer = new THREE.WebGLRenderer({
      canvas,
      antialias: !low,
      alpha: false,
      powerPreference: low ? "low-power" : "high-performance"
    });
  } catch (err) {
    fallbackMode();
    return;
  }

  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, low ? 1.25 : 1.75));
  renderer.setSize(stage.clientWidth, stage.clientHeight, false);
  renderer.setClearColor(0x000000, 1);
  if (THREE.SRGBColorSpace && "outputColorSpace" in renderer) {
    renderer.outputColorSpace = THREE.SRGBColorSpace;
  } else if (THREE.sRGBEncoding) {
    renderer.outputEncoding = THREE.sRGBEncoding;
  }
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = debug.exposure;
  renderer.shadowMap.enabled = !low;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;

  scene = new THREE.Scene();
  scene.fog = new THREE.FogExp2(0x000000, 0.018);
  camera = new THREE.PerspectiveCamera(debug.fov, stage.clientWidth / Math.max(stage.clientHeight, 1), 0.08, 24);
  camera.position.set(0, 0.12, 3.1);

  hemi = new THREE.HemisphereLight(0x6a6a74, 0x121214, 0);
  scene.add(hemi);
  key = new THREE.DirectionalLight(0xfff6ee, 0);
  key.position.set(2.15, 2.55, 2.85);
  key.castShadow = !low;
  if (!low) {
    key.shadow.mapSize.set(1024, 1024);
    key.shadow.camera.near = 0.5;
    key.shadow.camera.far = 12;
    key.shadow.camera.left = -2.2;
    key.shadow.camera.right = 2.2;
    key.shadow.camera.top = 2.2;
    key.shadow.camera.bottom = -2.2;
    key.shadow.bias = -0.00025;
  }
  scene.add(key);
  fill = new THREE.DirectionalLight(0xe8eaf4, 0);
  fill.position.set(-1.8, 1.55, 2.35);
  scene.add(fill);
  rim = new THREE.DirectionalLight(0xf2eee6, 0);
  rim.position.set(-2.2, 1.7, -2.6);
  scene.add(rim);
  const kicker = new THREE.DirectionalLight(0xe8e2d6, 0);
  kicker.position.set(3.8, 0.85, 0.45);
  scene.add(kicker);
  const wrap = new THREE.DirectionalLight(0xddd6cc, 0);
  wrap.position.set(0.35, 1.55, -3.1);
  scene.add(wrap);
  const camFill = new THREE.PointLight(0xfff4ea, 0, 8.5, 1.05);
  scene.add(camFill);
  pointerLight = new THREE.PointLight(0xfff6ea, 0, 6.5, 1.35);
  pointerLight.position.set(0.85, 0.95, 1.7);
  scene.add(pointerLight);

  floor = new THREE.Mesh(
    new THREE.CircleGeometry(3.2, 48),
    new THREE.MeshStandardMaterial({ color: 0x050505, roughness: 1, metalness: 0 })
  );
  floor.rotation.x = -Math.PI / 2;
  floor.position.y = -0.72;
  floor.receiveShadow = !low;
  scene.add(floor);

  const manager = new THREE.LoadingManager();
  manager.onProgress = (_url, loaded, total) => {
    const p = total ? Math.round((loaded / total) * 100) : 0;
    if (pctEl) pctEl.textContent = p + "%";
  };
  manager.onError = () => {};

  function texFromBitmap(bmp, srgb) {
    const tex = new THREE.Texture(bmp);
    tex.needsUpdate = true;
    tex.flipY = false;
    if (srgb) {
      if (THREE.SRGBColorSpace) tex.colorSpace = THREE.SRGBColorSpace;
      else if (THREE.sRGBEncoding) tex.encoding = THREE.sRGBEncoding;
    }
    tex.minFilter = THREE.LinearMipmapLinearFilter;
    tex.magFilter = THREE.LinearFilter;
    tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
    tex.generateMipmaps = true;
    return tex;
  }

  function prepMat(mat, rimMat) {
    if (!mat) return;
    mat.side = THREE.DoubleSide;
    mat.transparent = false;
    mat.alphaTest = 0;
    mat.depthWrite = true;
    if ("sheen" in mat) {
      mat.sheen = 0.32;
      mat.sheenColor = new THREE.Color(0x2a2a30);
      mat.sheenRoughness = 0.78;
    }
    mat.envMapIntensity = debug.env;
    mat.needsUpdate = true;
  }

  function showFallback() {
    fallbackMode();
  }

  function buildFromGlb(buffer) {
    const parsed = parseGlb(buffer);
    const json = parsed.json;
    const bin = parsed.bin;
    return Promise.all(json.images.map(function (_img, i) {
      return imageBitmapFromView(json, bin, i);
    })).then(function (bitmaps) {
      const maps = bitmaps.map(function (bmp, i) {
        return texFromBitmap(bmp, i < 2);
      });
      const mats = [
        new THREE.MeshPhysicalMaterial({
          map: maps[0],
          normalMap: maps[2],
          roughnessMap: maps[4],
          metalnessMap: maps[4],
          aoMap: maps[4],
          roughness: 1,
          metalness: 1,
          alphaTest: 0.45
        }),
        new THREE.MeshPhysicalMaterial({
          map: maps[1],
          normalMap: maps[3],
          roughnessMap: maps[5],
          metalnessMap: maps[5],
          aoMap: maps[5],
          roughness: 1,
          metalness: 1,
          alphaTest: 0.45
        }),
        new THREE.MeshStandardMaterial({
          color: 0x0b0b0c,
          roughness: 0.96,
          metalness: 0
        })
      ];
      mats.forEach(function (m, i) {
        prepMat(m, i === 2);
      });

      const group = new THREE.Group();
      json.meshes[0].primitives.forEach(function (prim) {
        const geo = new THREE.BufferGeometry();
        const pos = accessorArray(json, bin, prim.attributes.POSITION);
        const nrm = accessorArray(json, bin, prim.attributes.NORMAL);
        const uv = accessorArray(json, bin, prim.attributes.TEXCOORD_0);
        const idx = accessorArray(json, bin, prim.indices);
        geo.setAttribute("position", new THREE.BufferAttribute(pos, 3));
        geo.setAttribute("normal", new THREE.BufferAttribute(nrm, 3));
        geo.setAttribute("uv", new THREE.BufferAttribute(uv, 2));
        geo.setIndex(new THREE.BufferAttribute(idx, 1));
        const mesh = new THREE.Mesh(geo, mats[prim.material] || mats[2]);
        mesh.castShadow = !low;
        group.add(mesh);
      });
      return group;
    });
  }

  setPct(pctEl, 1);
  const watchdog = setTimeout(showFallback, 20000);

  loadGlb(absUrl(cfg.model), function (p) {
    setPct(pctEl, p * 0.92);
  })
    .then(buildFromGlb)
    .then(function (group) {
      garment = group;
      const box = new THREE.Box3().setFromObject(garment);
      const size = new THREE.Vector3();
      box.getSize(size);
      const center = new THREE.Vector3();
      box.getCenter(center);
      garment.position.sub(center);
      garment.position.y += 0.04;
      const s = 1.22 / Math.max(size.y, 0.001);
      garment.scale.setScalar(s);
      scene.add(garment);
      buildHotspots();
      clearTimeout(watchdog);
      startIntro();
    })
    .catch(function () {
      clearTimeout(watchdog);
      showFallback();
    });

  function uvToLocal(uv, side) {
    const x = ((side === "back" ? 1 - uv[0] : uv[0]) - 0.5) * 1.05;
    const y = (0.5 - uv[1]) * 1.05;
    const z = side === "back" ? -0.14 : 0.14;
    return new THREE.Vector3(x, y, z);
  }

  function buildHotspots() {
    HOTSPOTS.forEach((h) => {
      const el = document.createElement("button");
      el.type = "button";
      el.className = "rof3d-hot";
      el.setAttribute("aria-label", h.label);
      el.addEventListener("click", (e) => {
        e.stopPropagation();
        goSpot(h);
      });
      hotRoot.appendChild(el);
      hotEls.push({ h, el, local: uvToLocal(h.uv, h.side) });
    });
  }

  function projectHotspots() {
    if (!garment || !interactive || film) {
      hotEls.forEach((o) => {
        o.el.style.opacity = "0";
      });
      return;
    }
    const w = stage.clientWidth;
    const hgt = stage.clientHeight;
    hotEls.forEach((o) => {
      const p = o.local.clone();
      garment.localToWorld(p);
      const camDir = new THREE.Vector3();
      camera.getWorldDirection(camDir);
      const to = p.clone().sub(camera.position).normalize();
      const facing = o.h.side === "front" ? Math.cos(look.theta) > 0.15 : Math.cos(look.theta) < -0.15;
      p.project(camera);
      const x = (p.x * 0.5 + 0.5) * w;
      const y = (-p.y * 0.5 + 0.5) * hgt;
      o.el.style.left = x + "px";
      o.el.style.top = y + "px";
      o.el.style.opacity = facing && p.z < 1 ? "" : "0";
      o.el.style.pointerEvents = facing ? "auto" : "none";
    });
  }

  function startIntro() {
    if (loaderEl) {
      if (pctEl) pctEl.textContent = "100%";
      loaderEl.classList.add("is-gone");
    }
    introT = 0;
    ready = true;
    root.classList.add("is-ready");
  }

  function animateTo(next, ms) {
    const from = { theta: look.theta, phi: look.phi, radius: look.radius };
    anim = { from, next, t: 0, dur: ms / 1000 };
  }

  function goFront() {
    film = false;
    animateTo({ theta: home.theta, phi: home.phi, radius: home.radius }, 1400);
  }

  function goBack() {
    film = false;
    animateTo({ theta: Math.PI - home.theta, phi: home.phi, radius: home.radius }, 1600);
  }

  function goReset() {
    film = false;
    closeSpot();
    animateTo({ ...home }, 1200);
  }

  function goSpot(h) {
    film = false;
    const theta = h.side === "back" ? Math.PI - 0.28 : 0.28;
    animateTo({ theta, phi: 1.12, radius: 1.62 }, 1300);
    spotEl.hidden = false;
    spotEl.querySelector("[data-spot-idx]").textContent = h.index;
    spotEl.querySelector("[data-spot-label]").textContent = h.label;
  }

  function closeSpot() {
    spotEl.hidden = true;
  }

  function startFilm() {
    closeSpot();
    film = true;
    filmT = 0;
    interactive = false;
    root.classList.add("is-interacting");
  }

  function stopFilm() {
    film = false;
    interactive = true;
  }

  function filmPose(t) {
    const u = t / filmDur;
    const keys = [
      { t: 0, theta: home.theta, phi: home.phi, radius: home.radius },
      { t: 0.16, theta: 1.15, phi: 1.08, radius: 2.22 },
      { t: 0.32, theta: 1.85, phi: 1.12, radius: 2.05 },
      { t: 0.5, theta: Math.PI - 0.62, phi: 1.18, radius: 2.18 },
      { t: 0.68, theta: Math.PI + 0.35, phi: 1.1, radius: 2.0 },
      { t: 0.84, theta: -0.35, phi: 1.2, radius: 2.28 },
      { t: 1, theta: home.theta, phi: home.phi, radius: home.radius }
    ];
    let a = keys[0];
    let b = keys[1];
    for (let i = 0; i < keys.length - 1; i++) {
      if (u >= keys[i].t && u <= keys[i + 1].t) {
        a = keys[i];
        b = keys[i + 1];
      }
    }
    const span = Math.max(b.t - a.t, 0.0001);
    const k = easeInOut(clamp((u - a.t) / span, 0, 1));
    look.theta = lerp(a.theta, b.theta, k);
    look.phi = lerp(a.phi, b.phi, k);
    look.radius = lerp(a.radius, b.radius, k);
  }

  function applyLook() {
    const x = look.radius * Math.sin(look.phi) * Math.sin(look.theta);
    const y = look.radius * Math.cos(look.phi) + look.targetY;
    const z = look.radius * Math.sin(look.phi) * Math.cos(look.theta);
    camera.position.set(x, y, z);
    camera.lookAt(0, look.targetY, 0);
  }

  function tickIntro(dt) {
    if (introT < 0) return;
    introT += dt;
    const t = introT;
    const k = (v) => clamp(v, 0, 1);
    hemi.intensity = debug.hemi * easeOut(k(t / 0.9));
    key.intensity = debug.key * easeOut(k((t - 0.22) / 0.9));
    fill.intensity = debug.fill * easeOut(k((t - 0.4) / 1.0));
    rim.intensity = debug.rim * easeOut(k((t - 0.35) / 1.0));
    kicker.intensity = 0.42 * easeOut(k((t - 0.4) / 1.0));
    wrap.intensity = 0.55 * easeOut(k((t - 0.45) / 1.0));
    camFill.intensity = 1.45 * easeOut(k((t - 0.5) / 0.9));
    pointerLight.intensity = 0.7 * easeOut(k((t - 0.7) / 0.8));
    if (t < 2.5) {
      const camK = easeInOut(k((t - 0.08) / 2.35));
      look.theta = lerp(introFrom.theta, home.theta, camK);
      look.phi = lerp(introFrom.phi, home.phi, camK);
      look.radius = lerp(introFrom.radius, home.radius, easeOut(k((t - 0.12) / 2.2)));
    }
    if (t >= 2.6 && !interactive) interactive = true;
  }

  const ptr = { id: null, lx: 0, ly: 0, lx2: 0, ly2: 0, pinching: false, pdist: 0 };

  function onDown(e) {
    if (!interactive || film) return;
    dragging = true;
    touched = true;
    stage.classList.add("is-dragging");
    root.classList.add("is-interacting");
    closeSpot();
    if (e.pointerType !== "mouse") {
      try {
        stage.setPointerCapture(e.pointerId);
      } catch (err) {}
    }
    ptr.lx = e.clientX;
    ptr.ly = e.clientY;
  }

  function onMove(e) {
    const r = stage.getBoundingClientRect();
    pointer.tx = ((e.clientX - r.left) / r.width) * 2 - 1;
    pointer.ty = -(((e.clientY - r.top) / r.height) * 2 - 1);
    if (!dragging || !interactive || film) return;
    const dx = e.clientX - ptr.lx;
    const dy = e.clientY - ptr.ly;
    ptr.lx = e.clientX;
    ptr.ly = e.clientY;
    look.vTheta -= dx * 0.0055;
    look.vPhi -= dy * 0.0038;
  }

  function onUp() {
    dragging = false;
    stage.classList.remove("is-dragging");
  }

  function onWheel(e) {
    if (!interactive || film) return;
    e.preventDefault();
    look.vRadius += e.deltaY * 0.0016;
  }

  let pinch = 0;
  stage.addEventListener("touchstart", (e) => {
    if (e.touches.length === 2) {
      const a = e.touches[0];
      const b = e.touches[1];
      pinch = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
    }
  }, { passive: true });
  stage.addEventListener("touchmove", (e) => {
    if (!interactive || film || e.touches.length !== 2) return;
    const a = e.touches[0];
    const b = e.touches[1];
    const d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
    if (pinch) look.vRadius -= (d - pinch) * 0.012;
    pinch = d;
  }, { passive: true });

  stage.addEventListener("pointerdown", onDown);
  window.addEventListener("pointermove", onMove);
  window.addEventListener("pointerup", onUp);
  stage.addEventListener("wheel", onWheel, { passive: false });

  root.querySelectorAll("[data-act]").forEach((btn) => {
    btn.addEventListener("click", () => {
      touched = true;
      const act = btn.getAttribute("data-act");
      if (act === "front") goFront();
      if (act === "back") goBack();
      if (act === "reset") goReset();
      if (act === "zoom-in") look.vRadius -= 0.18;
      if (act === "zoom-out") look.vRadius += 0.18;
      if (act === "film") (film ? stopFilm() : startFilm());
      if (act === "spot-back") {
        closeSpot();
        goReset();
      }
    });
  });

  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && film) stopFilm();
  });

  function resize() {
    const w = stage.clientWidth;
    const h = Math.max(stage.clientHeight, 1);
    camera.aspect = w / h;
    camera.fov = debug.fov;
    camera.updateProjectionMatrix();
    renderer.setSize(w, h, false);
  }
  window.addEventListener("resize", resize);

  function loop(now) {
    const dt = Math.min((now - last) / 1000, 0.05);
    last = now;
    tickIntro(dt);

    pointer.x = lerp(pointer.x, pointer.tx, 0.06);
    pointer.y = lerp(pointer.y, pointer.ty, 0.06);
    pointerLight.position.x = pointer.x * 1.8;
    pointerLight.position.y = 0.9 + pointer.y * 0.7;
    pointerLight.position.z = 2.15;

    if (film) {
      filmT += dt;
      if (filmT >= filmDur) stopFilm();
      else filmPose(filmT);
    } else if (anim) {
      anim.t += dt / anim.dur;
      const k = easeInOut(clamp(anim.t, 0, 1));
      look.theta = lerp(anim.from.theta, anim.next.theta, k);
      look.phi = lerp(anim.from.phi, anim.next.phi, k);
      look.radius = lerp(anim.from.radius, anim.next.radius, k);
      look.vTheta = look.vPhi = look.vRadius = 0;
      if (anim.t >= 1) anim = null;
    } else if (interactive) {
      if (!touched && !film) {
        look.theta = home.theta + Math.sin(now * 0.00042) * 0.045;
      } else {
        look.theta += look.vTheta;
      }
      look.phi = clamp(look.phi + look.vPhi, lim.phiMin, lim.phiMax);
      look.radius = clamp(look.radius + look.vRadius, lim.rMin, lim.rMax);
      look.vTheta *= 0.9;
      look.vPhi *= 0.88;
      look.vRadius *= 0.86;
    }

    if (garment && introT > 0) {
      garment.rotation.y = 0;
      garment.position.y = debug.posY + Math.sin(now * 0.00055) * 0.008;
    }

    applyLook();
    hemi.intensity = debug.hemi * (introT < 0 ? 0 : Math.min(1, introT / 0.9));
    key.intensity = (introT < 0 ? 0 : key.intensity);
    if (introT > 0) {
      camFill.position.set(camera.position.x * 0.4, camera.position.y * 0.45 + 0.55, camera.position.z * 0.4);
    }
    renderer.toneMappingExposure = debug.exposure;
    projectHotspots();
    renderer.render(scene, camera);
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);

  if (debugWanted) {
    const box = document.createElement("div");
    box.className = "rof3d-debug";
    const fields = [
      ["key", 0, 3, 0.01],
      ["fill", 0, 2, 0.01],
      ["rim", 0, 3, 0.01],
      ["hemi", 0, 1.5, 0.01],
      ["exposure", 0.4, 1.6, 0.01],
      ["fov", 18, 50, 0.5],
      ["posY", -0.4, 0.5, 0.01]
    ];
    fields.forEach(([k, min, max, step]) => {
      const lab = document.createElement("label");
      lab.innerHTML = `<span>${k}</span>`;
      const inp = document.createElement("input");
      inp.type = "range";
      inp.min = min;
      inp.max = max;
      inp.step = step;
      inp.value = debug[k];
      inp.addEventListener("input", () => {
        debug[k] = parseFloat(inp.value);
        if (k === "key") key.intensity = debug.key;
        if (k === "fill") fill.intensity = debug.fill;
        if (k === "rim") rim.intensity = debug.rim;
        if (k === "hemi") hemi.intensity = debug.hemi;
        if (k === "fov") resize();
      });
      lab.appendChild(inp);
      box.appendChild(lab);
    });
    document.body.appendChild(box);
  }
})();
